import React from "react";
import { Bug, Lightbulb, MessageSquare } from "lucide-react";
import { CaresReportType } from "../types";
import "./ReportTypeSelector.css";

interface ReportTypeSelectorProps {
  value: CaresReportType;
  onChange: (value: CaresReportType) => void;
}

const OPTIONS: { value: CaresReportType; label: string; Icon: typeof Bug }[] = [
  { value: "Bug Report", label: "Bug", Icon: Bug },
  { value: "Suggestion", label: "Suggestion", Icon: Lightbulb },
  { value: "General Feedback", label: "Feedback", Icon: MessageSquare },
];

const ReportTypeSelector: React.FC<ReportTypeSelectorProps> = ({
  value,
  onChange,
}) => {
  return (
    <div className="mrc-type-selector" role="radiogroup" aria-label="Report type">
      {OPTIONS.map(({ value: optionValue, label, Icon }) => (
        <button
          key={optionValue}
          type="button"
          role="radio"
          aria-checked={value === optionValue}
          className={`mrc-type-option${value === optionValue ? " mrc-type-option--active" : ""}`}
          onClick={() => onChange(optionValue)}
        >
          <Icon size={16} />
          <span>{label}</span>
        </button>
      ))}
    </div>
  );
};

export default ReportTypeSelector;
